// What the play board tells the sky behind it, written by SkyBoard and read
// every frame by the sky's motion loop: its pan, for the parallax, and the
// quiet zones around playable nodes where nothing in the sky may move
// (Night Sky Construction, "Motion without distraction").
import { createStore } from '../../systems/store';

/** A circle in screen pixels. */
export interface QuietZone {
  x: number;
  y: number;
  r: number;
}

export interface BoardMotion {
  /** Changes when a new board mounts, so its first pan is not read as a move. */
  session: number;
  /** The board's pan, sky units. */
  pan: number;
  zones: QuietZone[];
}

export const boardMotion = createStore<BoardMotion | null>(null);

let sessions = 0;

export function nextBoardSession(): number {
  return ++sessions;
}

/** The quiet zones of a board's nodes at this pan and scale, the sky drawn `offsetY` units down the screen. */
export function quietZones(nodes: ReadonlyArray<{ x: number; y: number }>, pan: number, scale: number, radius: number, offsetY = 0): QuietZone[] {
  return nodes.map((n) => ({ x: (n.x - pan) * scale, y: (n.y + offsetY) * scale, r: radius * scale }));
}
